module.exports = __webpack_public_path__ + "media/images/platforms/xbox/connect-9a33e6df42f48a44cfab224379da71de.png";